/* KEON-Jo theme.js v17.16 - Studio v2 redesign (IndexBanner + Counter + SplitWords) */
/* KEON-Jō theme - cart drawer, reveal-on-scroll, AJAX cart */
(function(){
  'use strict';

  const reveals = document.querySelectorAll('.reveal');
  if ('IntersectionObserver' in window && reveals.length) {
    const io = new IntersectionObserver((entries) => {
      entries.forEach(e => {
        if (e.isIntersecting) { e.target.classList.add('is-visible'); io.unobserve(e.target); }
      });
    }, { rootMargin: '0px 0px -40px 0px', threshold: 0.05 });
    reveals.forEach(el => io.observe(el));
  } else {
    reveals.forEach(el => el.classList.add('is-visible'));
  }

  const drawer = document.getElementById('cart-drawer');
  const overlay = document.getElementById('cart-overlay');
  const openers = document.querySelectorAll('[data-cart-open]');
  const closers = document.querySelectorAll('[data-cart-close]');
  function openDrawer(){ if(drawer){ drawer.classList.add('is-open'); overlay.classList.add('is-open'); document.body.style.overflow='hidden'; } }
  function closeDrawer(){ if(drawer){ drawer.classList.remove('is-open'); overlay.classList.remove('is-open'); document.body.style.overflow=''; } }
  openers.forEach(b => b.addEventListener('click', e => { e.preventDefault(); openDrawer(); }));
  closers.forEach(b => b.addEventListener('click', e => { e.preventDefault(); closeDrawer(); }));
  document.addEventListener('keydown', e => { if(e.key === 'Escape') closeDrawer(); });

  // Currency-aware money formatter. Shopify stores all prices in shop-base subunits (cents for USD).
  // For visitors in other currencies, Shopify converts the raw cents value, so we always /100 to get the display value.
  function fmt(money){
    const sym = (window.theme && window.theme.cartCurrencySymbol) || '$';
    const code = (window.theme && window.theme.cartCurrencyCode) || 'USD';
    const noDec = ['JPY','KRW','VND','IDR','HUF','TWD','CLP','ISK','XAF','XOF','PYG','UGX'].indexOf(code) !== -1;
    const value = Number(money) / 100;
    if (noDec) {
      return sym + Math.round(value).toLocaleString('en-US');
    }
    return sym + value.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  }

  async function refreshCart(){
    try {
      const res = await fetch('/cart.js', { headers: { 'Accept': 'application/json' } });
      const cart = await res.json();
      document.querySelectorAll('[data-cart-count]').forEach(el => {
        el.textContent = String(cart.item_count).padStart(2, '0');
      });
      const body = document.getElementById('cart-drawer-body');
      const sub = document.getElementById('cart-drawer-sub');
      if (body) {
        if (!cart.items.length) {
          body.innerHTML = '<div class="cart-drawer__empty">your cart is empty.<br/>two objects are waiting.</div>';
        } else {
          body.innerHTML = cart.items.map(it => `
            <div class="cart-line" data-line-key="${it.key}">
              <div class="cart-line__media"><img src="${it.image || ''}" alt=""></div>
              <div>
                <div class="cart-line__name">${it.product_title}</div>
                <span class="cart-line__opt">${(it.variant_title || '')} · QTY ${it.quantity}</span>
                <button class="cart-line__remove" data-remove="${it.key}">REMOVE</button>
              </div>
              <span class="cart-line__price">${fmt(it.final_line_price)}</span>
            </div>
          `).join('');
        }
      }
      if (sub) sub.textContent = fmt(cart.total_price);
      document.querySelectorAll('[data-remove]').forEach(btn => {
        btn.addEventListener('click', async (e) => {
          const key = e.currentTarget.getAttribute('data-remove');
          await fetch('/cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id: key, quantity: 0 }),
          });
          refreshCart();
        });
      });
    } catch(err) { console.warn('cart refresh failed', err); }
  }

  document.querySelectorAll('form[data-add-form]').forEach(form => {
    form.addEventListener('submit', async (e) => {
      e.preventDefault();
      const btn = form.querySelector('[type="submit"]');
      const original = btn ? btn.textContent : '';
      if (btn) { btn.disabled = true; btn.textContent = 'ADDING…'; }
      const fd = new FormData(form);
      try {
        const res = await fetch('/cart/add.js', { method: 'POST', body: fd, headers: { 'Accept': 'application/json' } });
        if (!res.ok) throw new Error('add failed');
        await refreshCart();
        openDrawer();
      } catch(err) {
        form.submit();
      } finally {
        if (btn) { btn.disabled = false; btn.textContent = original; }
      }
    });
  });

  const variantPicker = document.querySelector('[data-variant-picker]');
  if (variantPicker) {
    const variants = window.__product_variants || [];
    const idInput = document.querySelector('[name="id"][data-variant-id]');
    const priceEl = document.querySelector('[data-product-price]');
    const wasEl = document.querySelector('[data-product-compare]');
    const submitBtn = document.querySelector('[data-add-submit]');
    const optionInputs = variantPicker.querySelectorAll('input[type="radio"]');
    function readSelected(){
      const opts = [];
      const groups = variantPicker.querySelectorAll('[data-option-group]');
      groups.forEach(g => {
        const checked = g.querySelector('input:checked');
        opts.push(checked ? checked.value : null);
      });
      return opts;
    }
    function syncVariant(){
      const opts = readSelected();
      const v = variants.find(v => {
        return ['option1','option2','option3'].every((k, i) => {
          if (opts[i] == null) return true;
          return v[k] == null ? true : v[k] === opts[i];
        }) && opts.filter(Boolean).length === [v.option1, v.option2, v.option3].filter(Boolean).length;
      }) || variants[0];
      if (!v) return;
      if (idInput) idInput.value = v.id;
      if (priceEl) priceEl.textContent = fmt(v.price);
      if (wasEl) {
        if (v.compare_at_price && v.compare_at_price > v.price) {
          wasEl.style.display = ''; wasEl.textContent = fmt(v.compare_at_price);
        } else { wasEl.style.display = 'none'; }
      }
      if (submitBtn) {
        if (v.available) {
          submitBtn.disabled = false;
          const symBtn = (window.theme && window.theme.cartCurrencySymbol) || '$';
          const priceClean = fmt(v.price).replace(/\.00$/, '').replace(symBtn, symBtn + ' ');
          submitBtn.textContent = `ADD TO CART · ${priceClean}`;
        } else { submitBtn.disabled = true; submitBtn.textContent = 'SOLD OUT'; }
      }
    }
    optionInputs.forEach(i => i.addEventListener('change', syncVariant));
    variantPicker.querySelectorAll('[data-option-group]').forEach(g => {
      g.addEventListener('change', () => {
        g.querySelectorAll('label.pdp__option').forEach(l => l.classList.remove('is-active'));
        const checked = g.querySelector('input:checked');
        if (checked) {
          const lbl = g.querySelector(`label[for="${checked.id}"]`);
          if (lbl) lbl.classList.add('is-active');
        }
      });
    });
    syncVariant();
  }

  document.querySelectorAll('[data-gallery]').forEach(gal => {
    const main = gal.querySelector('[data-gallery-main]');
    gal.querySelectorAll('[data-gallery-thumb]').forEach(t => {
      t.addEventListener('click', () => {
        const src = t.getAttribute('data-src');
        const alt = t.getAttribute('data-alt') || '';
        if (main && src) {
          const img = main.querySelector('img');
          if (img) { img.src = src; img.alt = alt; }
        }
        gal.querySelectorAll('[data-gallery-thumb]').forEach(x => x.classList.remove('is-active'));
        t.classList.add('is-active');
      });
    });
  });

  document.querySelectorAll('[data-index-banner]').forEach(banner => {
    const num = banner.querySelector('[data-preview-num]');
    const idxs = banner.querySelectorAll('[data-preview-idx]');
    const tags = banner.querySelectorAll('[data-preview-tag]');
    const years = banner.querySelectorAll('[data-preview-year]');
    const rows = banner.querySelectorAll('[data-rail-row]');
    function activate(row){
      const idx = row.getAttribute('data-idx');
      const tag = row.getAttribute('data-tag');
      const year = row.getAttribute('data-year') || '-';
      if (num) {
        num.style.animation = 'none';
        void num.offsetWidth;
        num.style.animation = '';
        num.textContent = idx;
      }
      idxs.forEach(el => el.textContent = idx);
      tags.forEach(el => el.textContent = tag);
      years.forEach(el => el.textContent = year);
      rows.forEach(r => {
        r.classList.toggle('is-active', r === row);
        const arrow = r.querySelector('.studio__rail-arrow');
        if (arrow) arrow.textContent = (r === row) ? '→' : '·';
      });
    }
    rows.forEach(r => {
      r.addEventListener('mouseenter', () => activate(r));
      r.addEventListener('focus', () => activate(r));
      r.addEventListener('click', () => activate(r));
    });
  });

  (function(){
    const pdp = document.querySelector('.pdp[data-product-handle]');
    if (!pdp) return;
    const main = pdp.querySelector('[data-gallery-main] img');
    if (!main) return;
    const defaultSrc = main.getAttribute('data-default-src') || main.src;
    const variants = window.__product_variants || [];
    if (!variants.length) return;
    const valueToImg = {};
    variants.forEach(v => {
      ['option1','option2','option3'].forEach(k => {
        const val = v[k];
        if (!val) return;
        const img = v.featured_image && v.featured_image.src;
        if (!img) return;
        const key = String(val).trim().toLowerCase();
        if (!valueToImg[key]) valueToImg[key] = img;
      });
    });
    pdp.querySelectorAll('[data-hover-swap]').forEach(label => {
      const val = (label.getAttribute('data-option-value') || '').trim().toLowerCase();
      const target = valueToImg[val];
      if (!target) return;
      label.addEventListener('mouseenter', () => { main.src = target; });
      label.addEventListener('focus', () => { main.src = target; });
    });
    pdp.addEventListener('mouseleave', () => {
      const checked = pdp.querySelector('input[type="radio"]:checked');
      if (checked) {
        const lbl = pdp.querySelector('label[for="' + checked.id + '"]');
        if (lbl) {
          const v = (lbl.getAttribute('data-option-value') || '').trim().toLowerCase();
          if (valueToImg[v]) { main.src = valueToImg[v]; return; }
        }
      }
      main.src = defaultSrc;
    });
    pdp.querySelectorAll('input[type="radio"]').forEach(input => {
      input.addEventListener('change', () => {
        const lbl = pdp.querySelector('label[for="' + input.id + '"]');
        if (!lbl) return;
        const v = (lbl.getAttribute('data-option-value') || '').trim().toLowerCase();
        if (valueToImg[v]) main.src = valueToImg[v];
        updateVariantThumbs(v);
      });
    });
    const variantLabel = pdp.querySelector('[data-thumbs-variant-label]');
    const variantSection = pdp.querySelector('[data-thumbs-variant-section]');
    function updateVariantThumbs(selectedKey){
      const thumbs = pdp.querySelectorAll('[data-thumbs-variant] [data-gallery-thumb]');
      let anyVisible = false;
      thumbs.forEach(t => {
        const key = (t.getAttribute('data-variant-key') || '').toLowerCase();
        if (key === selectedKey) { t.classList.remove('is-hidden'); anyVisible = true; }
        else { t.classList.add('is-hidden'); }
      });
      if (variantLabel && selectedKey) {
        variantLabel.textContent = selectedKey.toUpperCase() + ' VIEWS';
      }
      if (variantSection) {
        variantSection.style.display = anyVisible ? '' : 'none';
      }
    }
    const initialChecked = pdp.querySelector('input[type="radio"]:checked');
    if (initialChecked) {
      const lbl = pdp.querySelector('label[for="' + initialChecked.id + '"]');
      if (lbl) {
        const v = (lbl.getAttribute('data-option-value') || '').trim().toLowerCase();
        updateVariantThumbs(v);
      }
    } else {
      updateVariantThumbs('');
    }
  })();

  document.querySelectorAll('[data-locale-trigger]').forEach(trigger => {
    const kind = trigger.getAttribute('data-locale-trigger');
    const menu = document.querySelector('[data-locale-menu="' + kind + '"]');
    if (!menu) return;
    trigger.setAttribute('aria-expanded', 'false');
    trigger.setAttribute('aria-haspopup', 'true');
    trigger.addEventListener('click', e => {
      e.stopPropagation();
      document.querySelectorAll('[data-locale-menu]').forEach(m => {
        if (m !== menu) { m.hidden = true; const t = document.querySelector('[data-locale-trigger="' + m.getAttribute('data-locale-menu') + '"]'); if (t) t.setAttribute('aria-expanded', 'false'); }
      });
      const isOpen = !menu.hidden;
      menu.hidden = isOpen;
      trigger.setAttribute('aria-expanded', String(!isOpen));
    });
  });
  document.addEventListener('click', () => {
    document.querySelectorAll('[data-locale-menu]').forEach(m => {
      m.hidden = true;
      const t = document.querySelector('[data-locale-trigger="' + m.getAttribute('data-locale-menu') + '"]');
      if (t) t.setAttribute('aria-expanded', 'false');
    });
  });
  document.addEventListener('keydown', e => {
    if (e.key === 'Escape') {
      document.querySelectorAll('[data-locale-menu]').forEach(m => m.hidden = true);
      document.querySelectorAll('[data-locale-trigger]').forEach(t => t.setAttribute('aria-expanded', 'false'));
    }
  });

  document.querySelectorAll('[data-locale-filter]').forEach(input => {
    const menu = input.closest('[data-locale-menu]');
    if (!menu) return;
    input.addEventListener('input', () => {
      const q = input.value.trim().toLowerCase();
      menu.querySelectorAll('[data-locale-static]').forEach(el => { el.hidden = !!q; });
      menu.querySelectorAll('li[data-search]').forEach(li => {
        const text = li.getAttribute('data-search') || '';
        li.hidden = q && !text.includes(q);
      });
    });
    const kind = menu.getAttribute('data-locale-menu');
    const trigger = document.querySelector('[data-locale-trigger="' + kind + '"]');
    if (trigger) {
      trigger.addEventListener('click', () => {
        setTimeout(() => {
          if (!menu.hidden) {
            input.value = '';
            input.dispatchEvent(new Event('input'));
            input.focus();
          }
        }, 30);
      });
    }
    input.addEventListener('click', e => e.stopPropagation());
    input.addEventListener('keydown', e => {
      if (e.key === 'Enter') {
        const first = menu.querySelector('li[data-search]:not([hidden]) button');
        if (first) first.click();
      }
    });
  });

  if (window.matchMedia('(pointer: fine)').matches && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    const cur = document.createElement('div');
    cur.className = 'crosshair';
    document.body.appendChild(cur);
    let x = -100, y = -100, tx = -100, ty = -100;
    document.addEventListener('mousemove', e => { x = e.clientX; y = e.clientY; });
    document.addEventListener('mouseleave', () => cur.classList.add('is-hidden'));
    document.addEventListener('mouseenter', () => cur.classList.remove('is-hidden'));
    function tick() {
      tx += (x - tx) * 0.35;
      ty += (y - ty) * 0.35;
      cur.style.transform = `translate(${tx}px, ${ty}px) translate(-50%, -50%)`;
      requestAnimationFrame(tick);
    }
    requestAnimationFrame(tick);
    const hoverSel = 'a, button, .card, .btn, [data-hover-swap], .pdp__option, .studio__rail-row, .channeltile, .worktile, .liblock, .hero__feature-link';
    document.addEventListener('mouseover', e => { if (e.target.closest(hoverSel)) cur.classList.add('is-active'); });
    document.addEventListener('mouseout', e => { if (e.target.closest(hoverSel)) cur.classList.remove('is-active'); });
  }

  if ('IntersectionObserver' in window) {
    const io = new IntersectionObserver((entries) => {
      entries.forEach(e => {
        if (e.isIntersecting) { e.target.classList.add('is-revealed'); io.unobserve(e.target); }
      });
    }, { rootMargin: '0px 0px -10% 0px', threshold: 0.05 });
    document.querySelectorAll('[data-reveal-on-scroll]').forEach(el => io.observe(el));
    setTimeout(() => {
      document.querySelectorAll('[data-reveal-on-load]').forEach(el => el.classList.add('is-revealed'));
    }, 200);
  } else {
    document.querySelectorAll('[data-reveal-on-scroll], [data-reveal-on-load]').forEach(el => el.classList.add('is-revealed'));
  }

  if (drawer) refreshCart();

  document.querySelectorAll('[data-pdp-carousel]').forEach(car => {
    const track = car.querySelector('[data-pdp-carousel-track]');
    const dots = car.querySelector('[data-pdp-carousel-dots]');
    if (!track || !dots) return;
    const slides = track.querySelectorAll('.pdp__mobile-carousel-slide');
    if (slides.length <= 1) return;
    slides.forEach((_, i) => {
      const d = document.createElement('span');
      d.className = 'pdp__mobile-carousel-dot' + (i === 0 ? ' is-active' : '');
      dots.appendChild(d);
    });
    const dotEls = dots.querySelectorAll('.pdp__mobile-carousel-dot');
    let raf;
    track.addEventListener('scroll', () => {
      if (raf) cancelAnimationFrame(raf);
      raf = requestAnimationFrame(() => {
        const i = Math.round(track.scrollLeft / track.clientWidth);
        dotEls.forEach((d, j) => d.classList.toggle('is-active', j === i));
      });
    }, { passive: true });
    function teamKeyFromValue(val) {
      if (!val) return '';
      const m = String(val).toLowerCase().match(/team\s*(\d)/);
      return m ? 'team ' + m[1] : '';
    }
    function scrollToTeam(teamKey) {
      if (!teamKey) return;
      let target = -1;
      slides.forEach((s, i) => {
        if (target === -1 && s.getAttribute('data-team-key') === teamKey) target = i;
      });
      if (target >= 0) {
        track.scrollTo({ left: target * track.clientWidth, behavior: 'smooth' });
      }
    }
    document.querySelectorAll('[data-variant-picker] label[data-option-value]').forEach(lbl => {
      lbl.addEventListener('click', () => {
        const k = teamKeyFromValue(lbl.getAttribute('data-option-value'));
        if (k) setTimeout(() => scrollToTeam(k), 50);
      });
    });
  });

  const mobileMenu = document.querySelector('[data-mobile-menu]');
  if (mobileMenu) {
    const openBtns  = document.querySelectorAll('[data-mobile-menu-open]');
    const closeBtns = document.querySelectorAll('[data-mobile-menu-close]');
    const links     = mobileMenu.querySelectorAll('[data-mobile-menu-link]');
    function openMobileMenu() {
      mobileMenu.classList.add('is-open');
      mobileMenu.setAttribute('aria-hidden', 'false');
      document.body.classList.add('is-mobile-menu-open');
      openBtns.forEach(b => b.setAttribute('aria-expanded', 'true'));
    }
    function closeMobileMenu() {
      mobileMenu.classList.remove('is-open');
      mobileMenu.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('is-mobile-menu-open');
      openBtns.forEach(b => b.setAttribute('aria-expanded', 'false'));
    }
    openBtns.forEach(b => b.addEventListener('click', openMobileMenu));
    closeBtns.forEach(b => b.addEventListener('click', closeMobileMenu));
    links.forEach(l => l.addEventListener('click', closeMobileMenu));
    document.addEventListener('keydown', e => { if (e.key === 'Escape') closeMobileMenu(); });
    const triggers = mobileMenu.querySelectorAll('[data-mm-locale-trigger]');
    triggers.forEach(t => {
      t.addEventListener('click', (e) => {
        e.preventDefault();
        const which = t.getAttribute('data-mm-locale-trigger');
        const menu = mobileMenu.querySelector('[data-mm-locale-menu="' + which + '"]');
        if (!menu) return;
        const isOpen = !menu.hasAttribute('hidden');
        mobileMenu.querySelectorAll('[data-mm-locale-menu]').forEach(m => m.setAttribute('hidden',''));
        triggers.forEach(o => o.setAttribute('aria-expanded','false'));
        if (!isOpen) {
          menu.removeAttribute('hidden');
          t.setAttribute('aria-expanded','true');
          const search = menu.querySelector('[data-mm-locale-filter]');
          if (search) setTimeout(() => search.focus(), 50);
        }
      });
    });
    document.addEventListener('click', (e) => {
      if (!e.target.closest('.mobile-menu__locale-form')) {
        mobileMenu.querySelectorAll('[data-mm-locale-menu]').forEach(m => m.setAttribute('hidden',''));
        triggers.forEach(t => t.setAttribute('aria-expanded','false'));
      }
    });
    mobileMenu.querySelectorAll('[data-mm-locale-filter]').forEach(input => {
      const menu = input.closest('[data-mm-locale-menu]');
      if (!menu) return;
      input.addEventListener('input', () => {
        const q = input.value.trim().toLowerCase();
        menu.querySelectorAll('li').forEach(li => {
          const isStatic = li.hasAttribute('data-mm-locale-static') || li.classList.contains('mobile-menu__locale-search');
          if (isStatic) {
            li.style.display = q ? 'none' : '';
          } else {
            const t = li.getAttribute('data-search') || '';
            li.style.display = (!q || t.indexOf(q) !== -1) ? '' : 'none';
          }
        });
      });
    });
  }

  const reducedMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  function easeOutCubic(p) { return 1 - Math.pow(1 - p, 3); }
  function formatCounter(n, mode) {
    const v = Math.round(n);
    if (mode === 'K') {
      if (v >= 1000) {
        const k = v / 1000;
        return (k >= 10 ? k.toFixed(0) : k.toFixed(1).replace(/\.0$/, '')) + 'K';
      }
      return String(v);
    }
    return v.toLocaleString();
  }
  function runCounter(el) {
    const target   = parseFloat(el.getAttribute('data-counter')) || 0;
    const duration = parseInt(el.getAttribute('data-counter-duration'), 10) || 1200;
    const mode     = el.getAttribute('data-counter-format') || null;
    if (reducedMotion) { el.textContent = formatCounter(target, mode); return; }
    let start = null;
    const tick = (t) => {
      if (!start) start = t;
      const p = Math.min(1, (t - start) / duration);
      el.textContent = formatCounter(easeOutCubic(p) * target, mode);
      if (p < 1) requestAnimationFrame(tick);
    };
    requestAnimationFrame(tick);
  }
  const counters = document.querySelectorAll('[data-counter]');
  if (counters.length) {
    if ('IntersectionObserver' in window) {
      const cio = new IntersectionObserver((entries) => {
        entries.forEach(e => {
          if (e.isIntersecting) { runCounter(e.target); cio.unobserve(e.target); }
        });
      }, { threshold: 0.4 });
      counters.forEach(el => cio.observe(el));
    } else {
      counters.forEach(runCounter);
    }
  }

  document.querySelectorAll('[data-split-words]').forEach(el => {
    const text = el.textContent;
    const words = text.split(/(\s+)/);
    el.textContent = '';
    let i = 0;
    words.forEach(w => {
      if (/^\s+$/.test(w)) {
        el.appendChild(document.createTextNode(w));
        return;
      }
      const outer = document.createElement('span');
      outer.className = 'sw';
      const inner = document.createElement('span');
      inner.className = 'sw__inner';
      inner.style.setProperty('--sw-delay', (i * 70) + 'ms');
      inner.textContent = w;
      outer.appendChild(inner);
      el.appendChild(outer);
      i++;
    });
    if ('IntersectionObserver' in window) {
      const sio = new IntersectionObserver((entries) => {
        entries.forEach(e => {
          if (e.isIntersecting) { e.target.classList.add('is-visible'); sio.unobserve(e.target); }
        });
      }, { threshold: 0.2 });
      sio.observe(el);
    } else {
      el.classList.add('is-visible');
    }
  });

  function updateCollapseCounter(slot) {
    const root = document.querySelector('.case-study--' + slot);
    if (!root) return;
    const details = root.querySelectorAll('details.case-study__collapse');
    const openCount = [...details].filter(d => d.open).length;
    const total = details.length;
    const countEl = root.querySelector('[data-collapse-count="' + slot + '"]');
    if (countEl) countEl.textContent = openCount + ' / ' + total + ' OPEN';
    const toggleBtn = root.querySelector('[data-toggle-all="' + slot + '"]');
    if (toggleBtn) {
      toggleBtn.textContent = (openCount === total) ? 'COLLAPSE ALL ↑' : 'EXPAND ALL ↓';
    }
  }

  document.querySelectorAll('[data-toggle-all]').forEach(btn => {
    const slot = btn.getAttribute('data-toggle-all');
    const root = btn.closest('.case-study');
    if (!root) return;
    btn.addEventListener('click', () => {
      const details = root.querySelectorAll('details.case-study__collapse');
      const allOpen = [...details].every(d => d.open);
      details.forEach(d => { d.open = !allOpen; });
      updateCollapseCounter(slot);
    });
    root.querySelectorAll('details.case-study__collapse').forEach(d => {
      d.addEventListener('toggle', () => updateCollapseCounter(slot));
    });
    updateCollapseCounter(slot);
  });

})();
